import nextIcon from '../../assets/sprites/next.svg';
import prevIcon from '../../assets/sprites/prev.svg';

interface PaginationButtonsProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  ordersLength: number;
}

const PaginationButtons = ({
  currentPage,
  setCurrentPage,
  ordersLength,
}: PaginationButtonsProps) => {
  const totalPages = Math.ceil(ordersLength / 10);

  const renderPaginationButtons = () => {
    const maxButtons = 3;
    const buttons: JSX.Element[] = [];
    let startPage = 1;

    if (totalPages > maxButtons) {
      startPage = Math.max(currentPage - Math.floor(maxButtons / 2), 1);
    }

    if (startPage > 1) {
      buttons.push(
        <button
          key="first"
          className="px-3 py-1 text-[18px]"
          onClick={() => setCurrentPage(1)}
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(
          <button key="ellipsis-start" className="px-3 py-1 text-[18px] text-gray-400" disabled>
            ...
          </button>
        );
      }
    }

    for (let page = startPage; page <= Math.min(startPage + maxButtons - 1, totalPages); page++) {
      buttons.push(
        <button
          key={page}
          onClick={() => setCurrentPage(page)}
          className={`px-3 py-1 text-[18px] ${
            page === currentPage ? 'text-[#E3282A] font-semibold' : 'text-[#BCBCBC]'
          }`}
        >
          {page}
        </button>
      );
    }

    if (startPage + maxButtons - 1 < totalPages) {
      if (startPage + maxButtons < totalPages) {
        buttons.push(
          <button key="ellipsis-end" className="px-3 py-1 text-[18px] text-gray-400" disabled>
            ...
          </button>
        );
      }
      buttons.push(
        <button
          key="last"
          className="px-3 py-1 text-[18px]"
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="mt-4 flex justify-end items-center gap-1">
      {currentPage !== 1 && (
        <button onClick={() => setCurrentPage(currentPage - 1)}>
          <img src={prevIcon} alt="Назад" />
        </button>
      )}
      <div className="flex gap-1">{renderPaginationButtons()}</div>
      {currentPage !== totalPages && (
        <button onClick={() => setCurrentPage(currentPage + 1)}>
          <img src={nextIcon} alt="Вперёд" />
        </button>
      )}
    </div>
  );
};

export default PaginationButtons;
